import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMouseClassic2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMouseClassic2"><Path d="M18.5 15V2.5H5.5V15C5.5 18.5899 8.41015 21.5 12 21.5C15.5899 21.5 18.5 18.5899 18.5 15Z" stroke="currentColor" strokeLinecap="square"/><Path d="M12 2.5V9.5" stroke="currentColor"/><Path d="M5.75 9.5H18.25" stroke="currentColor"/></CentralIconBase>;
});

export default IconMouseClassic2;
